import { Button, Modal } from "@veneer/core";
import { ISimpleMessageOpenCloseDto } from "../../models/dto/application/ISimpleMessageDto";
import { useTranslation } from "react-i18next";

export default function SimpleMessageModalWithOpenClose(
  stateModal: ISimpleMessageOpenCloseDto
) {
  const [t] = useTranslation("global");

  return (
    <div style={{ position: "relative" }}>
      <Modal
        align="center"
        id="modal-id"
        closeButton
        show={stateModal.showModal}
        onClose={() => stateModal.setOpenCloseModal(!stateModal.showModal)}
        footer={
          <div style={{ textAlign: "center" }}>
            <Button
              onClick={() =>
                stateModal.setOpenCloseModal(!stateModal.showModal)
              }
            >
              {t("header.accept")}
            </Button>
          </div>
        }
        title={stateModal.modalTitle}
      >
        {typeof stateModal.modalMessage === "string" ? (
          <p style={{ textAlign: "center" }}>{stateModal.modalMessage}</p>
        ) : (
          <p
            style={{
              marginLeft: "20px",
              marginRight: "20px",
              lineHeight: "1.6",
              textAlign: "justify",
              fontSize: "15px",
              whiteSpace: "pre-line",
            }}
          >
            {stateModal.modalMessage}
          </p>
        )}
      </Modal>
    </div>
  );
}
